module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1031-4d88522c428035bdc535478a5832efe7.png";